import { memo, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import { getFinancialRatios } from "../../redux/actions/marketOverview";
import { getApiExchangeNameFromMktSegId, getScripDisplayDescription } from "../../utils/global_functions";
import { FINANCIAL_COLUMN, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { BzMasterAgGrid } from "../../components";
import { Col, Container, Row, Stack } from "react-bootstrap";
import moment from "moment";
import ZeroStates from "../ZeroStates";

const FundamentalRatios = ({isVertical=true}) =>{
    const dispatch = useDispatch();
    const gridRef = useRef()
    const [activeTabKey,setActiveTabKey] = useState('standalone')
    const [keyRatioData,setKeyRatioData] = useState([])
    const arrKeystatsFinancialRatio = useSelector(state=>state?.marketOverview?.arrKeystatsFinancialRatio);
    const scripOverviewData = useSelector(state=>state?.marketOverview?.scripOverviewData);
    useEffect(()=>{
        dispatch(getFinancialRatios({exchangeType:getApiExchangeNameFromMktSegId(scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID]),nToken:scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],jtenantToken: 1,type:activeTabKey==="standalone"?'S':'C'}))
    },[activeTabKey, dispatch, scripOverviewData])
    const HeaderComponent = ({ className, children }) => {
      return <div className={className}>{children}</div>;
    };
    const arrMainMenus = [
        {name:'Standalone',id:'standalone'},
        {name:'Consolidated',id:'consolidated'},
    ]
    const handleTab = (id) =>{
        setActiveTabKey(id)
    }
    useEffect(()=>{
      if(arrKeystatsFinancialRatio?.length){
        const columns = Object.keys(arrKeystatsFinancialRatio[0]);
        const transformData = []
        columns?.forEach((column,i)=>{
          transformData.push({
            Column:FINANCIAL_COLUMN[i],
            Year1: arrKeystatsFinancialRatio[0][column],
            Year2: arrKeystatsFinancialRatio[1][column],
            Year3: arrKeystatsFinancialRatio[2][column]
          })
        })
        setKeyRatioData(transformData)
      }
    },[arrKeystatsFinancialRatio])
    const columnDefs = [
        {
            headerComponent: () => <HeaderComponent className={'font-regular font-size3 color-text text-start'}></HeaderComponent>,
            field: 'Column',
            cellClass:'annual-reports-cell-left',
            width:130,
        },
        {
          field: 'Year1',
          headerComponent: () => <HeaderComponent className={'font-regular font-size3 color-text text-center'}>{keyRatioData?.[0]?.Year1?moment(keyRatioData?.[0]?.Year1,'YYYYMM').format('MMM YYYY'):'-'}</HeaderComponent>,
          cellClass:'annual-reports-cell-left',
          width:110
        },
        {
          field: 'Year2',
          headerComponent: () => <HeaderComponent className={'font-regular font-size3 color-text text-center'}>{keyRatioData?.[0]?.Year1?moment(keyRatioData?.[0]?.Year2,'YYYYMM').format('MMM YYYY'):'-'}</HeaderComponent>,
          cellClass:'annual-reports-cell-left',
          width:110
        },
        {
          field: 'Year3',
          headerComponent: () => <HeaderComponent className={'font-regular font-size3 color-text text-center'}>{keyRatioData?.[0]?.Year1?moment(keyRatioData?.[0]?.Year3,'YYYYMM').format('MMM YYYY'):'-'}</HeaderComponent>,
          cellClass:'annual-reports-cell-left',
          width:110
        },
    ]
    const onExportMarketMovement = useCallback(() => {
      if (keyRatioData?.length) {
        gridRef?.current?.api?.exportDataAsExcel({ fileName: `${scripOverviewData?.[WATCHLIST_GRID_INDEX.SYMBOL]}_${scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE]}_${getScripDisplayDescription(scripOverviewData)?.split(" ")?.join("")}_${activeTabKey==="standalone"?"Standalone":"Consolidated"}.xlsx` });
      }
    }, [keyRatioData, scripOverviewData]);
    return(
      <>
        {isVertical?
          <Container fluid className='p-0'>
              <div className='scripoverview-fieldset'>
              <div className='scripoverview-fieldset-sm'>
                  <div className='scripoverview-legend'>Financial Ratios</div>
                      <div className='submenu-wrapper horizontal-scroll-wrap pb-1 mt-3'>                    
                          <Stack direction="horizontal" className='d-flex justify-content-start'>
                              {
                                  arrMainMenus?.map((objMenu) => (
                                      <div className={`submenuItem ${activeTabKey === objMenu?.id ? "active" : ""}`} onClick={() => {handleTab(objMenu?.id)}} tabKey={objMenu?.id}>{objMenu?.name}</div>
                                  ))
                              }
                          </Stack>
                      </div>
                      {keyRatioData?.length?
                        <div className='mt-3'>
                            <div className='ag-theme-alpine'>
                                <BzMasterAgGrid className='so-analysis-fundamental-Financial-ratios' ref={gridRef} isCompress={true} arrRowData={keyRatioData.slice(1)} arrColumnData={columnDefs} defaultColProps={{flex:1}}/>
                            </div>
                        </div>
                        :
                        <div className='zero-state-alerts zero-state-alerts-lg'>
                          <ZeroStates subText="Could not find any data" icon='icon-64 icon-nodata mb-3 mrgauto' />
                        </div>
                      }
                  </div>
                  <div className='fixed-icons-wrapper'>
                    <div className='d-flex justify-content-end align-items-center'>
                      <div className='background-icon focus p-1' onClick={() => onExportMarketMovement()}>
                        <div className={`icon-16 icon-download ${keyRatioData?.length ? 'icon-dark' : 'icon-grey'}`}></div>
                      </div>
                  </div>
                </div>
              </div>
          </Container>
          :
          <Container fluid className='p-0 mt-3 side-tray-key-stats-font-size'>
            <Row className='g-0'>
              <Col className='font-medium font-size2 color-text'>Key Ratios</Col>                
            </Row>
            <Row className='g-0 py-2 gap-2 bdr-btm'>
              <Col>
                <div className='font-regular font-size1 color-subtext text-truncate'>EPS</div>
                <div className='font-medium font-size1 color-text'>{arrKeystatsFinancialRatio?.length?arrKeystatsFinancialRatio?.[0]?.EPS:'-'}</div>
              </Col>
              <Col>
                <div className='font-regular font-size1 color-subtext text-truncate'>P/E</div>
                <div className='font-medium font-size1 color-text'>{arrKeystatsFinancialRatio?.length?arrKeystatsFinancialRatio?.[0]?.PE:'-'}</div>
              </Col>
              <Col>
                <div className='font-regular font-size1 color-subtext text-truncate'>Sales Growth(%)</div>
                <div className='font-medium font-size1 color-text'>{arrKeystatsFinancialRatio?.length?arrKeystatsFinancialRatio?.[0]?.NetSalesGrowth:'-'}</div>
              </Col>
              <Col>
                <div className='font-regular font-size1 color-subtext text-truncate'>Dividend Yield(%)</div>
                <div className='font-medium font-size1 color-text'>{arrKeystatsFinancialRatio?.length?arrKeystatsFinancialRatio?.[0]?.DividendYield:'-'}</div>
              </Col>
            </Row>
            <Row className='g-0 py-2 gap-2 bdr-btm'>
              <Col>
                <div className='font-regular font-size1 color-subtext text-truncate'>Current Ratio</div>
                <div className='font-medium font-size1 color-text'>{arrKeystatsFinancialRatio?.length?arrKeystatsFinancialRatio?.[0]?.CurrentRatio:'-'}</div>                   
              </Col>
              <Col>
                <div className='font-regular font-size1 color-subtext text-truncate'>PEG</div>
                <div className='font-medium font-size1 color-text'>{arrKeystatsFinancialRatio?.length?arrKeystatsFinancialRatio?.[0]?.PEG:'-'}</div>                   
              </Col>

              <Col>
                <div className='font-regular font-size1 color-subtext text-truncate'>EBITDA(%)</div>
                <div className='font-medium font-size1 color-text'>{arrKeystatsFinancialRatio?.length?arrKeystatsFinancialRatio?.[0]?.EbitdaGrowth:'-'}</div>                   
              </Col>
              <Col>
                <div className='font-regular font-size1 color-subtext text-truncate'>PAT Growth(%)</div>
                <div className='font-medium font-size1 color-text'>{arrKeystatsFinancialRatio?.length?arrKeystatsFinancialRatio?.[0]?.PatGrowth:'-'}</div>                   
              </Col>
            </Row>
            <Row className='g-0 py-2 gap-2 bdr-btm'>
              <Col>
                <div className='font-regular font-size1 color-subtext text-truncate'>Debt to Equity</div>
                <div className='font-medium font-size1 color-text'>{arrKeystatsFinancialRatio?.length?arrKeystatsFinancialRatio?.[0]?.DebtEquityRatio:'-'}</div>                   
              </Col>
              <Col>
                <div className='font-regular font-size1 color-subtext text-truncate'>Quick Ratio</div>
                <div className='font-medium font-size1 color-text'>{arrKeystatsFinancialRatio?.length?arrKeystatsFinancialRatio?.[0]?.QuickRatio:'-'}</div>                   
              </Col>
              <Col>
                <div className='font-regular font-size1 color-subtext text-truncate'>&nbsp;</div>
                <div className='font-medium font-size1 color-text'>&nbsp;</div>                   
              </Col>
              <Col>
                <div className='font-regular font-size1 color-subtext text-truncate'>&nbsp;</div>
                <div className='font-medium font-size1 color-text'>&nbsp;</div>                   
              </Col>
            </Row>
          </Container>         
      }
    </>
    )
}
export default memo(FundamentalRatios);